export const VIN_WMI_STATUS_COLUMNS = Object.freeze([
  { prop: 'DiagMod', label: '原厂类型', width: '200' },
  { prop: 'make', label: '品牌', width: '160' },
  { prop: 'country', label: '国家', width: '160' },
  { prop: 'region', label: '区域', width: '180' },
  { prop: 'Year', label: '年款', width: '100' },
  { prop: 'scanCount', label: '收集次数', width: '100' },
  { prop: 'dateStr', label: '最近一次更新', width: '200' },
])

export function buildVinWmiMobileRows(item) {
  return [
    { key: 'make', label: '品牌', value: item?.make },
    { key: 'country', label: '国家', value: item?.country },
    { key: 'region', label: '区域', value: item?.region },
  ]
}

export function buildVinDiagModePresentation(item) {
  const text = String(item?.DiagMod || '').trim() || '-'
  const hint = String(item?.DiagModHint || '').trim()

  return {
    text,
    hint,
    hasHint: hint.length > 0,
  }
}

// 诊断分支字段的展示格式化：
// - null / undefined / 空字符串 显示为 '-'
// - 0 是合法值（收集次数为 0），必须显示为 0，不能因为 falsy 被吞掉
// - 其余值原样显示（含字符串 "NULL"、年份数字等）
export function formatVinWmiFieldValue(value) {
  if (value === null || value === undefined) return '-'
  const text = String(value).trim()
  return text === '' ? '-' : text
}
